import { Component, OnInit, HostListener } from '@angular/core';

import { Platform, MenuController } from '@ionic/angular';

import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CommonService } from './services/common.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    { title: 'Job Posting', url: 'job-posting', icon: 'briefcase' },
    { title: 'Job Application', url: 'application', icon: 'code-working' },
    { title: 'Enquiry', url: 'enquiry', icon: 'help' },
  ];
  public selectedIndex = 0;
  current_url = "";
  constructor(
    private platform: Platform,

    private router: Router,
    private location: Location,
    public menuCtrl: MenuController,
    public commonService: CommonService
    
  ) {

    this.router.events.subscribe(val => {
      if (location.path() != "") {
        this.current_url = this.router.url;
        
        this.selectedIndex = this.appPages.findIndex(d => d.url == location.path());
      }
    });
  }




}
